<template>
  <div class="base-kinostart" :class="$mq">
    <div class="text" v-html="kinostart"></div>
  </div>
</template>

<script>
export default {
  inject: ['kinostart'],
}
</script>

<style lang="scss" scoped>
.base-kinostart {
  margin-inline: auto;
  width: 70%;
  .text {
    display: inline-block;
    background-color: var(--clr-red);
    padding: 0.1em 1em;
    font-family: var(--ff-kinostart);
    color: var(--clr-kinostart);
    font-weight: var(--fw-kinostart);
    text-transform: uppercase;
    font-size: clamp(
      var(--fz-min-kinostart),
      var(--fz-preferred-kinostart),
      var(--fz-max-kinostart)
    );
  }
  &.md {
    width: 40%;
  }
  &.lg {
    width: 40%;
  }

  &.xl,
  &.xxl,
  &.xxxl {
    width: 35%;
  }
}
</style>
